module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppModal', {
    attrs: {
      "show": _vm.openFromOtherComponent
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_vm._v(">\n  "), _c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "marg-10-bottom"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.deleting_this_calendar')) + ":")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.calName))])]), _vm._v(" "), _c('div', {
    staticClass: "marg-10-bottom"
  }, [_c('h3', {
    staticClass: "warning-text bold"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.editCalendarDelete.all_data_will_be_deleted')) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarDelete.write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\" -\n        " + _vm._s(_vm.$t('vue2.editCalendarDelete.if_you_want_to_delete')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validatorText),
      expression: "validatorText"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.validatorText)
    },
    on: {
      "keyup": _vm.validateInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.validatorText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end align-center pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.validateInput()) ? _c('p', {
    staticClass: "warning-text marg-10-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.you_have_to_write')) + " \"" + _vm._s(_vm.$t('vue2.editCalendarDelete.validator_name')) + "\"\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
    staticClass: "submit-btn bttn--warning",
    on: {
      "click": _vm.submitDelete
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")]) : _c('button', {
    staticClass: "submit-btn--disabled"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarDelete.delete_calendar')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b33942e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditCalendars/EditCalendarDelete.vue
// module id = 1568
// module chunks = 1